import React from "react";
import { PaymentsButton } from "../customersPage.styled";
import { CiStopwatch } from 'react-icons/ci';
import { BiArrowBack } from "react-icons/bi";


/* eslint-disable react/prop-types */
function TransactionsHeader({handlePayments, tab, handleHistory}){

    return (
        <>
        {
            tab ?  <div className="end">
            <PaymentsButton onClick={handlePayments}>
            <CiStopwatch size={24}/>
               Upcoming payments
            </PaymentsButton>
           </div> : <div className='space-between'>
			
				<div onClick={handleHistory} style={{ color: "#408D94" }} className='flex gap-2 border'>
					<BiArrowBack size={24} />
					<p>Transactions History</p>
				</div>
			

		</div>
        }
        </>
       
    )
}

export default TransactionsHeader